<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室学生考勤</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="formInline.number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="学年学期">
          <el-select v-model="formInline.term" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="学生姓名" width="100px">
        </custom-table-column>
        <custom-table-column prop="number" label="学号" width="150">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="sign_count" label="签到次数" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleChildren(scope.row)" size="small">签到记录</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="签到记录" :visible.sync="detailDialogVisible" width="986px">
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="course_title" fixed label="课程名称" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="project_experiment_name" label="实训项目名称" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="training_room_name" label="教室" min-width="160px">
          </custom-table-column>
          <custom-table-column prop="week_count" label="周次" width="80px">
          </custom-table-column>
          <custom-table-column prop="node_count" label="节次" width="80px">
          </custom-table-column>
          <custom-table-column prop="sign_time" label="签到时间" width="180px">
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      formInline: {
        name: '',
        number: '',
        structure_1: '',
        term: ''
      },
      formInline1: {
        userId: ''
      },
      levell: [1],
      detailDialogVisible: false,
      tableData1: [],
      total1: 0,
      loading: false,
    };
  },
  created() {
    this.$store.dispatch('getTermms');
  },
  mounted() {
  },
  methods: {
    handleChildren(row) {
      this.formInline1.userId = row.id
      this.tableData1 = []
      this.detailDialogVisible = true;
      this.handleQuery1()
    },
    handleQuery1() {
      this.$refs.pageChild1.page = 1;
      this.$nextTick(() => {
        this.getList1();
      });
    },
    async getList1() {
      const params = { ...this.formInline1 };
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.instance.interfaceServer('api/sign-in/signInList', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/sign-in/studentList', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less">
.pageHeader:before {
  width: var(--width);
}

.el-cascader-node {
  height: auto !important;
  line-height: 2;
}

.el-cascader__dropdown {
  max-width: 100% !important;
  overflow: auto;
}

.el-cascader-node__label {
  line-height: 1.2;
}

.cascader-tip {
  color: rgb(132, 146, 166);
  font-size: 13px;
  max-width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 12px;
}
</style>
